/*
  tr-search.js — tiroir de recherche.

  La frappe est temporisée et chaque requête annule la précédente : sans
  cela, taper « jogging » lance sept recherches dont six sont périmées, et
  la dernière réponse arrivée n'est pas forcément la dernière demandée —
  on affiche alors les résultats de « joggi » sur une saisie « jogging ».
*/

if (!customElements.get('tr-search')) {
  customElements.define(
    'tr-search',
    class TrSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-search-input]');
        this.idle = this.querySelector('[data-search-idle]');
        this.live = this.querySelector('[data-search-live]');
        this.panel = this.querySelector('.tr-search__panel');
        this.controller = null;
        this.timer = null;

        this.querySelectorAll('[data-search-close]').forEach((node) => {
          node.addEventListener('click', () => this.close());
        });

        if (this.input) {
          this.input.addEventListener('input', () => this.schedule());
        }

        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-search-open]')) {
            event.preventDefault();
            this.open();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
      }

      open() {
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        // Le focus va au champ, pas au panneau : ici l'intention du
        // visiteur est de taper, pas de lire.
        if (this.input) this.input.focus({ preventScroll: true });
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.documentElement.style.removeProperty('overflow');
      }

      schedule() {
        window.clearTimeout(this.timer);
        this.timer = window.setTimeout(() => this.run(), 250);
      }

      showIdle() {
        if (this.idle) this.idle.hidden = false;
        if (this.live) {
          this.live.hidden = true;
          this.live.innerHTML = '';
        }
      }

      async run() {
        const terms = (this.input?.value || '').trim();
        if (terms.length < 2) {
          this.showIdle();
          return;
        }

        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        this.classList.add('is-busy');

        const root = window.Shopify?.routes?.root || '/';
        const url =
          `${root}search/suggest?q=${encodeURIComponent(terms)}` +
          '&resources[type]=product,collection,query' +
          '&resources[limit]=6' +
          '&section_id=tr-predictive-search';

        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('suggest failed');
          const html = await response.text();
          const fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-search-results]');
          if (!fresh || !this.live) return;
          this.live.innerHTML = fresh.innerHTML;
          this.live.hidden = false;
          if (this.idle) this.idle.hidden = true;
        } catch (error) {
          // Une requête annulée n'est pas une panne : elle a été remplacée
          // par la suivante, il n'y a rien à signaler ni à effacer.
          if (error.name === 'AbortError') return;
          this.showIdle();
        } finally {
          this.classList.remove('is-busy');
        }
      }
    }
  );
}
